module.exports = __webpack_public_path__ + "static/img/doc.248dbda.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons-actividad/doc.png
// module id = 215
// module chunks = 1